import axios from "axios";
import dayjs from "dayjs";
import { store } from "../../App";

const CREATE = "/expenses/create";
const UPDATE = "/expenses/update";

export const createExpense = async (data) => {
  try {
    let res;
    if (data._id) {
      res = await axios.put(UPDATE + `/${data._id}`, data);
    } else {
      res = await axios.post(CREATE, data);
    }
  } catch (e) {
    throw e;
  }
};

export const fetchExpenses = async (data) => {
  const centerId = JSON.parse(localStorage.getItem("centerId")).centerId;

  try {
    const res = await axios.get(
      `/expenses?centerId=${centerId}&startDate=${dayjs().format("YYYY-MM-DD")}&normalExpenses=true`
    );
    store.dispatch({ type: "FETCH_EXPENSES", data: res.data });
  } catch (e) {
    throw e;
  }
};
